// extracted by mini-css-extract-plugin
module.exports = {"mask":"hero-mask-module--mask--4V2Ax"};